import { ChangeDetectionStrategy, Component, inject, input, viewChild } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { allEventVariables } from '@consts/alerts-v2.const';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { NODE_EDIT_TAB_COMPONENT, SelectedNodeForEdit } from 'src/app/shared/flow-chart/flow-chart.model';
import { UiTextAreaVariablesComponent } from 'src/app/shared/ui-kit/ui-text-area-variables/ui-text-area-variables.component';
import { MobilePushNodeData } from '../../../node-edit.type';
import { OrgUsersSelectComponent } from '../../org-users-select/org-users-select.component';

@Component({
  selector: 'edit-mobile-push',
  imports: [
    TranslatePipe,
    ReactiveFormsModule,
    OrgUsersSelectComponent,
    UiTextAreaVariablesComponent,
  ],
  templateUrl: './edit-mobile-push.component.html',
  styleUrl: './edit-mobile-push.component.scss',
  providers: [
    {
      provide: NODE_EDIT_TAB_COMPONENT,
      useExisting: EditMobilePushComponent,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditMobilePushComponent {
  public selectedNodeForEdit = input<SelectedNodeForEdit<MobilePushNodeData>>();
  public disableForm = input<boolean>(false);
  public markSelectAsTouched = input<boolean>(false);

  private readonly fb = inject(UntypedFormBuilder);
  private readonly translateService = inject(TranslateService);

  public readonly selectVariablesAutoComplete = allEventVariables;

  public selectSig = viewChild(OrgUsersSelectComponent);

  public form: UntypedFormGroup = this.fb.group({
    name: [
      this.translateService.instant('FLOW_CHART.NODES.MOBILE_PUSH.NAME'),
      [Validators.required],
    ],
    orgUserIds: [[], [Validators.required]],
    body: ['', [Validators.required],],
    title: ['', [Validators.required],],
  });

  public ngOnInit(): void {
    if (this.disableForm()) {
      this.form.disable();
    }

    if (this.markSelectAsTouched()) {
      this.selectSig()?.control?.markAsTouched();
    }

    if (this.selectedNodeForEdit()?.data?.name) {
      this.form.setValue({
        name: this.selectedNodeForEdit().data.name,
        orgUserIds: this.selectedNodeForEdit().data.orgUserIds || [],
        body: this.selectedNodeForEdit().data.body || '',
        title: this.selectedNodeForEdit().data.title || '',
      })
    }
  }
}
